import {useMemo} from 'react'

import {SESSION_STORAGE_KEYS} from '../../infra/constants/sessionStorageKeys'

const {TESTING_SUBDOMAIN_PREFIX, COMPANY_DOMAIN} = window.env

export const useIframeConfig = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const sourceEnvFromUrl = urlParams.get('source_env')

  const sourceEnv = useMemo(() => {
    if (sourceEnvFromUrl) {
      sessionStorage.setItem(
        SESSION_STORAGE_KEYS.SOURCE_ENV_KEY,
        sourceEnvFromUrl
      )
      return sourceEnvFromUrl
    }

    return sessionStorage.getItem(SESSION_STORAGE_KEYS.SOURCE_ENV_KEY)
  }, [sourceEnvFromUrl])

  const iframeBaseUrl = useMemo(() => {
    if (sourceEnv && sourceEnv.startsWith(TESTING_SUBDOMAIN_PREFIX)) {
      return `https://${sourceEnv}.${COMPANY_DOMAIN}.com`
    }

    if (sourceEnv && sourceEnv === 'localhost') {
      return 'http://localhost:3001'
    }

    return window.env.REACT_APP_IFRAME_PARENT_URL
  }, [sourceEnv])

  return {iframeBaseUrl, sourceEnv}
}
